var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18,
    r: 18,
    fill: "#F6EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 14.7085H23.75V23.3335C23.75 26.5091 21.3995 29.0835 18.5 29.0835C15.6005 29.0835 13.25 26.5091 13.25 23.3335V14.7085Z",
    fill: "#7D6299",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 9.9165C11.8918 9.9165 11.5 10.3456 11.5 10.8748C11.5 11.4041 11.8918 11.8332 12.375 11.8332H13.25V23.3332C13.25 26.5088 15.6005 29.0832 18.5 29.0832C21.3995 29.0832 23.75 26.5088 23.75 23.3332V11.8332H24.625C25.1082 11.8332 25.5 11.4041 25.5 10.8748C25.5 10.3456 25.1082 9.9165 24.625 9.9165H23.75H22H15H13.25H12.375ZM22 11.8332H15V23.3332C15 25.4503 16.567 27.1665 18.5 27.1665C20.433 27.1665 22 25.4503 22 23.3332V11.8332Z",
    fill: "#7D6299"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.375 20.4582C19.8582 20.4582 20.25 20.0291 20.25 19.4998C20.25 18.9706 19.8582 18.5415 19.375 18.5415C18.8918 18.5415 18.5 18.9706 18.5 19.4998C18.5 20.0291 18.8918 20.4582 19.375 20.4582ZM17.625 24.2915C18.1082 24.2915 18.5 23.8624 18.5 23.3332C18.5 22.8039 18.1082 22.3748 17.625 22.3748C17.1418 22.3748 16.75 22.8039 16.75 23.3332C16.75 23.8624 17.1418 24.2915 17.625 24.2915Z",
    fill: "#7D6299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabTest);
export default __webpack_public_path__ + "static/media/lab-test.9b68807f7c1c2db8aaeb33ae21646741.svg";
export { ForwardRef as ReactComponent };